import * as Yup from "yup";

const DOLLAR_IN_MILLICENTS = 100 * 1000;

export function formatMillicentsAsDollars(millicents: number): string {
  return (millicents / DOLLAR_IN_MILLICENTS).toString();
}

export function formatMillicentsAsDollarFraction(millicents: number): string {
  return formatMillicentsAsDollars(millicents).slice(2); // remove the "0."
}

export function parseDollarFractionAsMillicents(
  dollarFraction: string
): number {
  return Math.round(Number(`0.${dollarFraction}`) * DOLLAR_IN_MILLICENTS);
}

export const dollarFractionValidator = Yup.string()
  .matches(/^\d+$/, "Enter a number")
  .test("min-value", "Pricing must be at least $0.00001", value => {
    const asNum = Number(value);
    return asNum >= 1;
  })
  .max(
    5,
    "Pricing cannot use increments of less than one one-thousandth of a cent"
  )
  .required("Required");
